import { Performer } from './performers.data';
import { LabelObject, Ranking, Venue } from './events.data';
import { Sponsor } from './sponsors.data';
import { JoiFile } from './files.model';
import { Program } from './../store/programs.data';
import { copyObjectWithProps, AllSameKeyValuesEnforcer } from '../helpers/helpers';
import { BriefType } from './share.data';
import { Exhibitor } from './exhibitors.data';
import { BrandingData, HomePageData } from './publish.data';
import { Dictionary } from './app.data';
// TODO removed because of ts conflicts // import { Dictionary } from '@ngrx/entity';

export type EntityCalendarQueryType = BriefType | 'wf' | 'oss' | 'eventList' | 'event'
export interface EntityCalendarQueryData {
  entityType: EntityCalendarQueryType
  id: string
  eventId: string
  shareCode: string
}

export interface PublicEventInfo {
  eventId: string
  event_title:string
  title: string
  description: string
  event_dates_string: string[]
  venues: {[key:string]:Venue}
  performers: { [key:string]: Performer }
  profilePerformers: { [key:string]: Performer }
  sponsors: {[key:string]: Sponsor}
  exhibitors: { [key: string]: Exhibitor }
  sponsorGroupings: { sponsorTypeId: string, ids: string[] }[]
  profileSponsors: {[key:string]: Sponsor}
  profileExhibitors: {[key:string]: Exhibitor}
  exhibitorIds: string[]
  sponsorTypes: { [tId:string]: Ranking }
  performer_labels: LabelObject
  sponsor_labels: LabelObject
  program_labels: LabelObject
  session_labels: LabelObject
  exhibitor_labels: LabelObject
  viewMyTimezoneToggle: boolean
  performerRoles: Dictionary<Ranking>
}

export interface PublicEventData {
  timeZoneIdsByProgram: { [pId:string]: string }
  timeline: PublicTimelineItem[][]
  eventInfo: PublicEventInfo
  hideMadeWithJoi?: boolean
  CTALinks?: JoiFile[]
  venue?: Venue
  excludedFieldIds?: string[]
  tabNames?: { [tId: string]: string }
  error?: any
  customPublishCSSUrl?: string
  internalVersion: number
  brandingData: BrandingData
  homePageData: HomePageData
  publishVersion?: number
}

export interface PublicProgram {
  id: string
  title: string
  date: string
  days: number
  labels: string[]
  location: string
  venueId: string
  order: number
  expectedNumber?: number
}
const publicProgramProps: AllSameKeyValuesEnforcer<PublicProgram> = { id: 'id', title: 'title', date: 'date', days: 'days', labels: 'labels', location: 'location', venueId: 'venueId', order: 'order', expectedNumber: 'expectedNumber' } 
const publicProgramPropsSet = new Set(Object.values(publicProgramProps))

export const createPublicProgram = (program: Program): PublicProgram => copyObjectWithProps(publicProgramPropsSet, program) as PublicProgram

export interface PublicTimelineItem {
  id: string
  duration: number
  title: string
  on_day: number
  start: string
  timezoneAbbr: string
  timeZoneId: string
  epoch: number
  end: string
  description: string
  labels: string[]
  performerIds: string[]
  sponsorIds: string[]
  publicLinks: JoiFile[]
  date?: string
  datetime?: string
  displayDate?: string // for overriding display dates
  program?: PublicProgram
  session_date?: any // previously string | number
  is_first_in_date_group?: boolean
  programId: string

  performerRoleIds: {[id: string]: string} //  Dictionary<string>
}